module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-60197c08e4ce383a31100d2b7cd320fc.svg";